<template>
	<svg
		fill="none"
		height="89"
		version="1.1"
		viewBox="0 0 90 89"
		width="90">
		<circle
			cx="14"
			cy="45"
			r="11.5"
			stroke="#000000"
			stroke-width="5" />
		<circle
			cx="62"
			cy="14"
			r="11.5"
			stroke="#000000"
			stroke-width="5" />
		<circle
			cx="62"
			cy="75"
			r="11.5"
			stroke="#000000"
			stroke-width="5" />
		<circle
			cx="76"
			cy="45"
			r="11.5"
			stroke="#000000"
			stroke-width="5" />
		<rect
			fill="#000000"
			height="6"
			width="44"
			x="23"
			y="42" />
		<rect
			fill="#000000"
			height="6"
			transform="rotate(-35.1122)"
			width="37.484798"
			x="-4.6124964"
			y="44.80888" />
		<rect
			fill="#000000"
			height="5.9999971"
			transform="matrix(0.81802739,0.57517927,0.57517927,-0.81802739,0,0)"
			width="37.484779"
			x="47.277885"
			y="-28.990276" />
	</svg>
</template>
